export default __webpack_public_path__ + "static/media/fund-2.a3389ceb.jpeg";